import { useSchedulingMode } from '../useSchedulingMode'

const useIsFitterSchedulingMode = () => {
  const mode = useSchedulingMode()

  return mode === 'fitter'
}

export { useIsFitterSchedulingMode }
